import config from "./appconf";

function LogoutButton() {
  const handleClick = () => {
    console.log("clicking logout button");
    fetch(`${config.baseUrl}/api/v1/logout`, {
      method: "POST",
      mode: "cors",
      credentials: "include",
    })
      .then((data) => {
        console.log("returned from fetching logout");
      })
      .catch((error) => {
        console.log("received error from fetch logout");
        console.log(error);
      });
  };

  return (
    <button className="actionButton" onClick={handleClick}>
      Logout
    </button>
  );
}

export default LogoutButton;
